<img [isVip]="isVip" [lcAvatar]="photoUrl || 'assets/images/user.png'">
